import React, {Fragment, FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {State} from "@App/state";
import {OrganizationIsLeaseplan} from "@App/utils/conditionals/organization";
import {
    OrganizationIsLeasePlanAndServiceIsNotWheelchangeAndServiceIsNotGlass
} from "@App/utils/conditionals/combinations";

export const NoGarageFound: FunctionComponent = () => {

    const {t} = useTranslation()
    const organization = useSelector((state: State) => state.orders.organization)
    const service = useSelector((state: State) => state.orders.service)


    return (
        <div className="bg-white p-4 rounded">
            <div className={"text-xl font-bold mb-3"}>
                {t('garageList.emptyState.headline')}
            </div>

            <p className={"mb-3"}>
                {t('garageList.emptyState.description')}
            </p>
            <div className={"mb-3"}>
                <ul>
                    {t('garageList.emptyState.bullet-point-1') && (
                        <li className="ml-2">
                            {t('garageList.emptyState.bullet-point-1')}
                        </li>
                    )}
                    {t('garageList.emptyState.bullet-point-2') && (
                        <li className="ml-2">
                            {t('garageList.emptyState.bullet-point-2')}
                        </li>
                    )}
                </ul>
            </div>

            {OrganizationIsLeasePlanAndServiceIsNotWheelchangeAndServiceIsNotGlass(organization, service) && (
                <div className={'mb-3'}>
                    <p>{t('garageList.emptyState.radiusHint')}</p>
                </div>
            )}

            {!OrganizationIsLeaseplan(organization) && (
                <Fragment>
                    <div className={"font-bold mb-3"}>{t('hotline.hotline-headline')}</div>
                    <div className="flex gap-1 mb-3">
                        <div>
                            <div>
                                <a href={t('hotline.hotline-phone-link')}
                                   className={"text-primary text-2xl"}
                                   title="repareo Werkstattmeister anrufen">
                                    {t('hotline.hotline-phone')}
                                </a>
                            </div>
                            {t('hotline.hotline-availability')}
                        </div>
                    </div>
                    {t('hotline-via-email-email') && (
                        <div>
                            {t('hotline.hotline-via-email')}
                            <a href={'mailto:' + t('hotline.hotline-via-email-email')}
                               title="Eine Anfrage per E-Mail senden">
                                {t('hotline.hotline-via-email-email')}
                            </a>
                        </div>
                    )}
                </Fragment>
            )}


        </div>
    );
}
